import { IncomingIcon } from "@/Images"

export const PAYMENT_TABS = [
  {
    title: "Payments List",
    icon: <IncomingIcon />,
  },
]
